<div *transloco="let t" style="margin-bottom: 20px;">
  <div style="margin-bottom: 6px;" class="body-xs-semibold"> {{ t(title) }}</div>

  <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate" [nzStatus]="validator?.['status']">

    <input [dropSpecialCharacters]="dropSpecialCharacters" [thousandSeparator]="thousandSeparator" [mask]="mask"
      (input)="enforceMaxLength($event)" [appUppercase]="isCapitalRequired" [disabled]="disabled" #myInput
      (focus)="moveCursorToEnd()" [style.text-align]="text_align" [type]="type" class="body-sm-medium" [value]="value"
      (input)="onInput($event)" style="border-radius: 8px; height: 48px; " nz-input [placeholder]="t(placeholder)"
      nzSize="large" />

  </nz-input-group>

  <ng-template #prefixTemplate>
    <div class="body-sm-medium">
      {{ prefix }}
    </div>
  </ng-template>

  <ng-template #suffixTemplate>
    <div class="body-sm-medium">
      {{ suffix }}
    </div>
  </ng-template>


  <div class="error-message"> {{ validator?.['error_message'] === null ? '' : t(validator['error_message']) }} </div>
</div>